<template>
  <div>
    <el-row type="flex" justify="center">
      <el-col :span="16" :xs="24">
        <!-- 基本信息 -->
        <section class="basic-info clearfix" :class="{'basic-info-mobile': isMobile}">
          <div class="pull-left">
            <p class="name el-button--text forbid-hover-status">{{profile.zh_name}}<small>{{profile.en_name}}</small></p>
            <p class="school-info">
              <template v-if="profile.title">
                {{profile.title}}
                <template v-if="(profile.tutor && profile.tutor != '无') || profile.degree === '博士'">/</template>
              </template>
              <template v-if="profile.tutor && profile.tutor != '无'">
                {{profile.tutor}}
                <template v-if="profile.degree === '博士'">/</template>
              </template>
              <template v-if="profile.degree === '博士'">{{profile.degree}}</template>
              @{{profile.school_name}}
            </p>
          </div>
          <div class="pull-right">
            <span class="pageviews">
              <i class="iconfont icon--show"></i>
              {{visiteCount}}
            </span>
            <template v-if="loginUser">
              <template v-if="loginUser.liked">
                <el-button
                  type="text"
                  icon="iconfont icon--goods"
                  @click="liked"
                  class="like">
                  {{likeCount}}
                </el-button>
              </template>
              <template v-else>
                <el-button
                  type="text"
                  icon="iconfont icon--good"
                  @click="likeAction"
                  class="like">
                  {{likeCount}}
                </el-button>
              </template>
            </template>
            <template v-else>
              <el-button
                type="text"
                icon="iconfont icon--good"
                @click="likeAction"
                class="like">
                {{likeCount}}
              </el-button>
            </template>
          </div>
        </section>
      </el-col>
    </el-row>
    <p class="line el-button--primary forbid-hover-status"></p>
    <template v-if="status === 0">
      <p class="message">暂无学术信息</p>
    </template>
    <template v-else>
      <p class="message">暂未开通学术主页</p>
      <template v-if="loginUser && loginUser.is_self === 1">
        <template v-if="isMobile">
          <div class="open-scholar-wrap">
            <el-button type="primary" @click="createScholar">创建我的学术主页</el-button>
          </div>
        </template>
        <template v-else>
          <el-button
            class="el-button el-button--text open-scholar"
            @click="createScholar">立即开通</el-button>
        </template>
      </template>
      <template v-else>
        <template v-if="isMobile">
          <div class="open-scholar-wrap">
            <el-button type="primary" @click="shareMasking = true">邀请开通</el-button>
          </div>
        </template>
        <template v-else>
          <el-button
            class="el-button el-button--text open-scholar"
            @click="dialogVisible = true">邀请开通</el-button>
        </template>
      </template>
    </template>
    <FooterAd
      v-if="profile"
      :isMobile="isMobile"
      :loginUser="loginUser"
      :name="profile.zh_name"
      @createMyHomepage="createScholar"
      :fixed="false">
    </FooterAd>

    <Invite
      :name="profile && profile.zh_name"
      :dialogVisible="dialogVisible"
      :url="url"
      @closeDialog="dialogVisible = false">
    </Invite>

    <!-- 移动端邀请开通的弹窗 -->
    <div class="share-masking" v-if="shareMasking" @click="shareMasking = false">
      <img src="../../pages/HomepageMobile/image/invite_mobile.png" alt="">
    </div>
  </div>
</template>
<script>
import FooterAd from '@/components/FooterAd'
import Invite from '@/components/Invite'
import { Toast } from 'mint-ui'

export default {
  props: {
    profile: Object,
    loginUser: Object,
    isMobile: Boolean,
    likeCount: Number,
    visiteCount: Number,
    status: Number
  },
  data () {
    return {
      dialogVisible: false,
      url: window.location.origin,
      shareMasking: false
    }
  },
  components: {
    FooterAd,
    Invite
  },
  methods: {
    likeAction () {
      this.$emit('likeAction')
    },
    liked () {
      if (this.isMobile) {
        Toast('您已经点过赞啦')
      } else {
        this.$message('您已经点过赞啦')
      }
    },
    createScholar () {
      this.$emit('createScholar')
    }
  }
}
</script>
<style scoped lang="scss">
  @import './index.scss';
  #app .footer-ad {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/NotPublic/index.vue